module.exports = __webpack_public_path__ + "media/SpotifyCompactDark.69d4aa5c.png";